export const LOAD_COMMANDS_MENU_LIST = 'load_commands_menu_list';
export const COMMANDS_MENU_LIST_LOADED = 'set_loaded_commands_menu_list';
export const COMMAND_MENU_DELETED = 'commands_menu_deleted';
export const RESET_COMMANDS_MENU_LIST = 'reset_commands_menu_list';
export const SYNC_FAILED = 'commands_menu_sync_error';
